import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-layout-grid-line",
    title: "影视分类浏览",
    desc: "按内容分类、类型、地区、年份多维度筛选，快速找到想看的剧集与电影。",
  },
  {
    icon: "ri-book-open-line",
    title: "剧情资料整理",
    desc: "提供完整剧情简介、分集剧情脉络与演职人员资料，方便快速了解故事全貌。",
  },
  {
    icon: "ri-refresh-line",
    title: "更新动态提示",
    desc: "同步展示剧集更新状态与最新上线信息，追更不再错过新内容。",
  },
  {
    icon: "ri-search-line",
    title: "关键词搜索",
    desc: "支持按剧名、演员、导演、类型等关键词检索，精准定位目标作品。",
  },
];

export default function About() {
  return (
    <div className="w-full">
      <div className="bg-primary-950">
        <div className="w-full px-4 md:px-8 pt-6 pb-12">
          <nav className="flex items-center gap-1.5 text-xs md:text-sm text-background-300/80 mb-4">
            <Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-base"></i>
            <span className="text-background-100 font-medium">关于我们</span>
          </nav>
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-background-50">关于我们</h1>
          <p className="mt-3 text-sm md:text-base text-background-200/90 max-w-2xl leading-relaxed">
            “邻居的妻子影视大全”是一个专注影视剧集与剧情介绍的内容资讯平台，为影视爱好者整理清晰、可靠的作品资料。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <section className="max-w-3xl">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2 mb-4">
            <span className="w-1 h-5 rounded-full bg-accent-500 inline-block"></span>
            站点介绍
          </h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-loose">
            <p>
              我们以“邻居的妻子”这一品牌为核心，围绕影视作品搭建了一个便于浏览与查找的内容门户。在这里，你可以按内容分类、影视类型、地区与年份筛选作品，查看每部作品的剧情简介、演职人员资料与更新状态，并通过专题合集发现同题材的更多佳作。
            </p>
            <p>
              我们希望把散乱、零碎的影视信息整理成结构清晰、易于阅读的资料，让每一位观众在决定是否追一部剧之前，都能快速了解它的故事与看点。
            </p>
          </div>
        </section>

        <section className="mt-12">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2 mb-6">
            <span className="w-1 h-5 rounded-full bg-accent-500 inline-block"></span>
            服务范围
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {services.map((s) => (
              <div key={s.title} className="p-5 rounded-lg bg-background-100 border border-background-200">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${s.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">{s.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-12">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2 mb-4">
            <span className="w-1 h-5 rounded-full bg-accent-500 inline-block"></span>
            版权及免责声明
          </h2>
          <div className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6 space-y-4 text-sm text-foreground-700 leading-loose">
            <p>
              本站所列影视作品的名称、简介、演职人员等信息均整理自公开渠道，仅用于剧情资讯展示与学习交流，不用于任何商业用途。
            </p>
            <p>
              本站不提供在线播放、资源下载、会员充值等服务，页面中出现的更新状态与集数信息仅作内容说明。相关作品的著作权归原权利人所有，如权利人认为内容存在问题，欢迎通过联系我们页面进行反馈，我们会及时处理。
            </p>
            <p>
              对于因使用本站信息而产生的任何直接或间接影响，本站不承担相应责任。请在遵守当地法律法规的前提下浏览与使用本站内容。
            </p>
          </div>
        </section>

        <div className="mt-12 flex flex-wrap items-center gap-3 rounded-lg bg-primary-950 p-6 md:p-8">
          <div className="flex-1 min-w-[220px]">
            <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">有建议或需要反馈？</h3>
            <p className="mt-1.5 text-sm text-background-200/90">欢迎随时告诉我们你的想法，帮助我们做得更好。</p>
          </div>
          <Link
            to="/contact"
            className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer"
          >
            <i className="ri-mail-send-line"></i>
            前往联系我们
          </Link>
        </div>
      </div>
    </div>
  );
}